import { createFileRoute } from '@tanstack/react-router';
import { AGGREGATE_NAMES, TEMPLATE_RESOLVERS } from 'cpool-constants';
import { divisionId } from 'cpool-schemas';
import {
    schemaTemplateResolver_GetFooters,
    schemaTemplateResolver_GetHeaders,
    schemaTemplateResolver_ListDivisionHeaderFooters,
} from 'cpool-tables/backend-resolvers';
import { z } from 'zod';

import { ROLES } from '~/constants';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { getResolverName } from '~/features/headerFooterTemplate/utils/getResolverName';
import { getQueryOptions } from '~/queryUtils/getQueryOptions';

const headersQueryOptions = getQueryOptions({
    aggregateName: AGGREGATE_NAMES.TEMPLATE,
    resolverName: getResolverName('headers'),
    schema: schemaTemplateResolver_GetHeaders,
});
const footersQueryOptions = getQueryOptions({
    aggregateName: AGGREGATE_NAMES.TEMPLATE,
    resolverName: getResolverName('footers'),
    schema: schemaTemplateResolver_GetFooters,
});

const divisionHeaderFootersQueryOptions = getQueryOptions({
    aggregateName: AGGREGATE_NAMES.TEMPLATE,
    resolverName: TEMPLATE_RESOLVERS.listDivisionHeaderFooters,
    schema: schemaTemplateResolver_ListDivisionHeaderFooters,
});

export const Route = createFileRoute('/_app/management/header_footer/')({
    beforeLoad: ({ location }) => {
        authoriseUser([ROLES.admin, ROLES.email_manager], location);
        const content = 'ROUTE_TITLE.MAIL_HEADER_FOOTER';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    loader: async ({ context }) => {
        await Promise.all([
            context.queryClient.ensureQueryData(headersQueryOptions),
            context.queryClient.ensureQueryData(footersQueryOptions),
            context.queryClient.ensureQueryData(divisionHeaderFootersQueryOptions),
        ]);
    },
    // a malformed id falls back to the standard editor like an unknown one
    validateSearch: z.object({ divisionId: divisionId.optional().catch(undefined) }),
});
